import Toast from 'bootstrap/js/dist/toast';
import Tooltip from 'bootstrap/js/dist/tooltip';
import Dropdown from 'bootstrap/js/dist/dropdown';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

/* global verityObj: false */

class Auth {
	constructor() {
		const acidToken = getCookie('acidToken');
		const request = new URL(location.href).searchParams.get('request');
		const isDashboard = location.href.startsWith(verityObj.dashboardPermalink);
		this.validateAuth(acidToken, request, isDashboard);
	}

	validateAuth(acidToken, request, isDashboard) {
		if ('confirm' === request) {
			clearURLQueryStrings();
			new RenderView('join', {formID: 'signUpForm'});
			switchToJoinTab();
		} else if ('resetPassword' === request) {
			new RenderView('reset-password');
		} else if (isDashboard && acidToken) {
			fetchDashboardData();
		} else {
			initMenuLink();
			new RenderView('join');
		}
	}
}

/**
 * @property {string} signIn - string
 * @property {string} profileUpdated - string
 * @property {string} confirmEmail - string
 * @property {string} forgotPassword - string
 * @property {string} resetPassword - string
 * @property {string} emailConfirmedSuccessfully - string
 */
class ValidateForm {
	constructor(form, fields) {
		this.form = form;
		this.fields = fields;
		this.latinOnlyFields = ['firstname', 'lastname'];
		this.optionalFields = ['memberMobPhoneNo'];
		this.passwordFields = ['signInPassword', 'newPassword', 'confirmNewPassword', 'confirmPassword', 'MyProfilePassword', 'signUpPassword', 'signUpConfirmPassword'];
		this.confirmPasswordForms = ['changePasswordForm', 'resetPasswordForm', 'signUpForm'];
		this.confirmPasswordFields = {
			'confirmNewPassword': 'newPassword',
			'confirmPassword': 'newPassword',
			'signUpConfirmPassword': 'signUpPassword'
		};
		this.uppercaseRegex = /[A-Z]/;
		this.lowercaseRegex = /[a-z]/;
		this.numberRegex = /[1-9]/;
		this.specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
		this.allowedCharRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;

		this.validateOnSubmit.bind(this)();
		this.validateOnType.bind(this)();
	}

	validateOnType() {
		Array.from(this.latinOnlyFields).forEach((latinOnlyField) => {
			latinOnlyField = document.querySelector(`input[name=${latinOnlyField}]`);
			if (latinOnlyField) {
				latinOnlyField.addEventListener('keyup', () => {
					if (this.allowedCharRegex.test(latinOnlyField.value)) {
						this.removeStatus(latinOnlyField)
					} else {
						this.setStatus(latinOnlyField, `${_.uppercaseFirstLetter(latinOnlyField.name)} must have latin characters only`, 'error');
					}
				});
			}
		});
	}

	validateOnSubmit() {
		this.form.addEventListener('submit', (event) => {

			event.preventDefault();
			let error = 0;

			this.fields.forEach((field) => {
				const input = document.querySelector(`#${this.form.id} [name="${field}"]`);
				this.removeStatus(input);
				if (this.validateFields.bind(this)(input) === false) {
					error++;
				}
			});

			if (error === 0) {
				dispatchEvent(new CustomEvent('validateForm.Start'));

				const formData = new FormData(this.form);
				const fetchData = {};

				formData.forEach((value, key) => {
					fetchData[key] = value;
				});

				handleSubmitButton(this.form, false);
				handleMessage(this.form.id, '/api/UserLogin' === fetchData.verity_guest_action ? verityObj.messages.signIn : '', 'success');

				fetchAction(fetchData).then(data => {
					let message;
					if (data) {
						if ('string' === typeof data.data || 'object' === typeof data.data) {
							if ('string' === typeof data.data.errorMessage && 'ok' !== data.data.errorMessage.toLowerCase()) {
								message = data.data.errorMessage;
							} else if (data && 'boolean' === typeof data.success && 'string' === typeof data.data) {
								message = data.data;
							} else if (data.data.acid) {
								if ('/api/UserLogin' === fetchData.verity_guest_action) {
									message = `${verityObj.messages.signInWelcome}, ${data.data?.memberInfo?.memberFirstName?.toLowerCase() ?? data.data?.memberInfo?.memberEmail?.toLowerCase()}`;
									setUserInfo(data.data);
									setCookies(data.data, fetchData.rememberMe);
									fetchDashboardData();
								}
							} else if (data.success && ('/rmtJoin' === fetchData.verity_guest_action || '/OptIn' === fetchData.verity_guest_action)) {
								message = verityObj.messages.success;
							} else if (200 === data.data.errorCode && '/api/Account' === fetchData.verity_guest_action) {
								if ('PUT' === fetchData.verity_guest_method) {
									message = verityObj.messages.profileUpdated;
									updateProfileData(fetchData);
								} else if ('POST' === fetchData.verity_guest_method) {
									message = verityObj.messages.confirmEmail;
								}
							} else if (200 === data.data.errorCode && '/api/ForgotPassword' === fetchData.verity_guest_action) {
								if ('PUT' === fetchData.verity_guest_method) {
									message = verityObj.messages.forgotPassword;
									redirectToDashboard();
								} else if ('GET' === fetchData.verity_guest_method) {
									message = verityObj.messages.resetPassword;
								}
							}

							handleMessage(this.form.id, message, data.success ? 'success' : 'danger');
						} else if (data && 'object' === typeof data && 'string' === typeof data.data) {
							handleMessage(this.form.id, data.data, data.success ? 'success' : 'danger');
						} else {
							handleMessage(this.form.id, verityObj.messages.error, 'danger');
						}
						dispatchEvent(new CustomEvent('validateForm.End', {
							detail: {
								status: data.success,
								data: data.data,
							}
						}));
					}
				}).then(() => {
					handleSubmitButton(this.form, true);
					locomotiveScrollUpdate();
				});

				locomotiveScrollUpdate();
				triggerGoogleAnalyticsFormSubmit(this.form);
			}
		});
	}

	validateFields(field) {
		if (field.value.trim() === "") {
			if (this.optionalFields.includes(field.name)) {
				return true;
			}

			this.setStatus(field, `${_.uppercaseFirstLetter(field.name)} cannot be blank`, 'error');
			return false;
		} else {
			if (this.passwordFields.includes(field.id)) {
				if (field.value.length < 8) {
					this.setStatus(field, `${_.uppercaseFirstLetter(field.name)} must be at least 8 characters`, 'error');
					return false;
				} else if (field.value.length > 16) {
					this.setStatus(field, `${_.uppercaseFirstLetter(field.name)} must be at most 16 characters`, 'error');
					return false;
				} else if (!this.uppercaseRegex.test(field.value)) {
					this.setStatus(field, `${_.uppercaseFirstLetter(field.name)} must contain one uppercase character`, 'error');
					return false;
				} else if (!this.lowercaseRegex.test(field.value)) {
					this.setStatus(field, `${_.uppercaseFirstLetter(field.name)} must contain one lowercase character`, 'error');
					return false;
				} else if (!this.numberRegex.test(field.value)) {
					this.setStatus(field, `${_.uppercaseFirstLetter(field.name)} must contain one number`, 'error');
					return false;
				} else if (!this.specialCharRegex.test(field.value)) {
					this.setStatus(field, `${_.uppercaseFirstLetter(field.name)} must contain one special character (!^+%/()=?_:\`@˜|\\}][{$.,*-)`, 'error');
					return false;
				} else if (!this.allowedCharRegex.test(field.value)) {
					this.setStatus(field, `${_.uppercaseFirstLetter(field.name)} must contain only latin characters`, 'error');
					return false;
				} else {
					let passwordFieldsErrors = 0;
					if (this.confirmPasswordForms.contains(field.form.id)) {
						for (let confirmPasswordField in this.confirmPasswordFields) {
							let PasswordField = this.confirmPasswordFields[confirmPasswordField];
							if (confirmPasswordField !== PasswordField) {
								let passwordFieldEL = document.getElementById(PasswordField);
								let confirmPasswordFieldEL = document.getElementById(confirmPasswordField);
								if (passwordFieldEL && confirmPasswordFieldEL && passwordFieldEL.value !== confirmPasswordFieldEL.value) {
									this.setStatus(field, `Passwords must match`, 'error');
									passwordFieldsErrors++;
								}
							}
						}
					}

					if (passwordFieldsErrors) {
						return false;
					}
				}
				if (!this.allowedCharRegex.test(field.value)) {
					this.setStatus(field, `${_.uppercaseFirstLetter(field.name)} must have latin characters only`, 'error');
					return false;
				}

				this.setStatus(field, null, 'success');
				return true;
			}
		}
	}

	setStatus(field, message, status) {
		const messageEl = field.parentElement.querySelector('.message') || field.parentElement.parentElement.querySelector('.message');
		if (messageEl && message) {
			if (status === 'success') {
				if (messageEl) {
					messageEl.innerText = '';
					messageEl.classList.remove('d-none', 'alert', 'alert-danger');
					messageEl.classList.add('d-none');
				}
			}

			if (status === 'error') {
				messageEl.innerText = message;
				messageEl.classList.add('d-none', 'alert', 'alert-danger');
				messageEl.classList.remove('d-none');
			}
		}
	}

	removeStatus(field) {
		const messageEl = field.parentElement.querySelector('.message') || field.parentElement.parentElement.querySelector('.message');
		if (messageEl) {
			messageEl.innerText = '';
			messageEl.classList.remove('alert', 'alert-danger', 'alert-success');
			messageEl.classList.add('d-none');
		}
	}
}

class RenderView {
	constructor(view, data = {}) {
		this.signInfields = ['username', 'password', 'rememberMe'];
		this.signUpfields = ['email', 'firstname', 'lastname', 'password', 'confirmPassword'];
		this.optInfields = ['email'];
		this.rmtJoinfields = ['email'];
		this.changePasswordFields = ['currentPassword', 'newPassword', 'confirmNewPassword'];
		this.forgotPasswordFields = ['email'];
		this.resetPasswordFields = ['email', 'newPassword', 'confirmPassword'];
		this.profileUpdateFields = ['firstname', 'lastname', 'email', 'memberMobPhoneNo', 'birthday', 'nationality', 'memberAddress', 'city', 'memberPostCode', 'country', 'promotionalMailAccepted'];
		this.preferenceFields = [];
		this.MissingPointsFields = ['subject', 'location', 'reservationNumber', 'arrivalDate', 'departureDate', 'bookingSource'];
		this.render(view, data);
	}

	render(view, data) {
		if (!wp.template) console.error('wp-util not enqueued');

		const mailingListContainer = document.getElementById('verity-guest-mailing-list-content');
		if (mailingListContainer) {
			const optInForm = document.getElementById('optInForm');
			if (optInForm) {
				new ValidateForm(optInForm, this.optInfields)
			}
			const rmtJoinForm = document.getElementById('rmtJoinForm');
			if (rmtJoinForm) {
				new ValidateForm(rmtJoinForm, this.rmtJoinfields);
			}
		}

		const loyaltyContainer = document.getElementById('verity-guest-loyalty-content');
		if (loyaltyContainer) {
			let verityTemplate = wp.template(`verity-guest-loyalty-${view}`);
			loyaltyContainer.innerHTML = verityTemplate(data);

			if ('join' === view) {
				if (data && 'object' === typeof data && data.formID) {
					handleMessage(data.formID, verityObj.messages.emailConfirmedSuccessfully, 'success');
				}

				const signInForm = document.getElementById('signInForm');
				if (signInForm) {
					new ValidateForm(signInForm, this.signInfields);
				}

				const signUpForm = document.getElementById('signUpForm');
				if (signUpForm) {
					new ValidateForm(signUpForm, this.signUpfields);
				}

				triggerDatePickers();
			}

			if ('dashboard' === view) {
				const verityHeaderContainer = document.getElementById('wrapper-navbar') || document.getElementById('site-navbar');
				if (verityHeaderContainer) {
					verityTemplate = wp.template(`verity-guest-loyalty-${view}-header-mobile`);
					data.dashboardPermalink = verityObj.dashboardPermalink;
					data.dashboardPermalinkTarget = verityObj.dashboardPermalinkTarget;
					verityHeaderContainer.insertAdjacentHTML('beforeend', verityTemplate(data));
				}

				const profileUpdateForm = document.getElementById('profileUpdateForm');
				if (profileUpdateForm) {
					new ValidateForm(profileUpdateForm, this.profileUpdateFields);
				}

				const preferencesUpdateForm = document.getElementById('preferencesUpdateForm');
				if (preferencesUpdateForm) {
					new ValidateForm(preferencesUpdateForm, this.preferenceFields);
					updatePreference();
				}

				const missingPointsForm = document.getElementById('missingPointsForm');
				if (missingPointsForm) {
					new ValidateForm(missingPointsForm, this.MissingPointsFields);
				}

				hotelSelectChange();

				triggerDatePickers();

				missingPointsDatesOnSubjectSelect();

				initSignOutLinks();
			}

			if ('reset-password' === view) {
				const resetPasswordForm = document.getElementById('resetPasswordForm');
				if (resetPasswordForm) {
					new ValidateForm(resetPasswordForm, this.resetPasswordFields);
					clearURLQueryStrings();
				}
			}

			if ('change-password' === view) {
				const changePasswordForm = document.getElementById('changePasswordForm');
				if (changePasswordForm) {
					new ValidateForm(changePasswordForm, this.changePasswordFields);
				}
			}

			if ('forgot-password' === view) {
				const forgotPasswordForm = document.getElementById('forgotPasswordForm');
				if (forgotPasswordForm) {
					new ValidateForm(forgotPasswordForm, this.forgotPasswordFields)
				}
			}
		}

		triggerTabs();

		triggerTooltips();

		triggerDropdowns();

		// initMenuLink(data);

		initChangeViewLinks(data);

		updateBookNowEls(data);

		triggerPasswordReveal();

		locomotiveScrollUpdate();

		dispatchEvent(new CustomEvent('view.rendered', {
			detail: {view, data}
		}));
	}
}

const fetchDashboardData = () => {
	let userInfo = getUserInfo();
	initMenuLink(userInfo);
	if (userInfo.hasOwnProperty('acid') && userInfo.hasOwnProperty('memberInfo')) {

		const fetchMemberProfile = fetchAction({
			'verity_guest_action': '/api/Account',
			'verity_guest_method': 'GET',
			'acid': userInfo.acid
		});

		const fetchVisitList = fetchAction({
			'verity_guest_action': '/api/VisitList',
			'verity_guest_method': 'GET',
			'acid': userInfo.acid
		});

		const fetchPreferences = fetchAction({
			'verity_guest_action': '/api/PreferencesNew',
			'verity_guest_method': 'GET',
			'acid': userInfo.acid
		});

		Promise.all([fetchMemberProfile, fetchVisitList, fetchPreferences]).then((values) => {
			values.forEach((value, index) => {
				if (value && 'object' === typeof value.data) {
					if (index === 0) {
						userInfo.memberProfile = value.data;
					} else if (index === 1) {
						userInfo.visitList = value.data;
					} else if (index === 2 && 'object' === typeof value.data.prefNewList && value.data.prefNewList[0] && 'object' === typeof value.data.prefNewList[0].preferencesElement) {
						userInfo.preferences = value.data.prefNewList[0].preferencesElement;
					}
				} else {
					toastInit(verityObj.messages.error)
				}
			});

			setUserInfo(userInfo);
			new RenderView('dashboard', userInfo);
		});
	}
}

const fetchAction = async (data) => {
	const fetchData = new URLSearchParams({
		'action': verityObj.ajaxAction,
		'nonce': verityObj.ajaxNonce,
		...data
	});

	let fetchOptions = {
		method: 'POST',
		body: fetchData,
	};

	return await fetch(verityObj.ajaxUrl, fetchOptions)
		.then((response) => {
			if (response.ok) {
				return response.json();
			}
			throw response;
		})
		.then((data) => {
			return data;
		})
		.catch((error) => {
			console.warn(error);
		})
}

/**
 * @param data
 */
const updateProfileData = (data) => {
	let userInfo = getUserInfo();

	userInfo.memberProfile = Object.keys(userInfo.memberProfile).reduce((accumulator, key) => {
		accumulator[key] = data[key] || userInfo.memberProfile[key]
		return accumulator;
	}, {});

	if (userInfo.hasOwnProperty('memberInfo') && data.hasOwnProperty('firstname') && data.hasOwnProperty('lastname') && data.hasOwnProperty('email')) {
		userInfo.memberInfo.memberFirstName = data.firstname;
		userInfo.memberInfo.memberLastName = data.lastname;
		userInfo.memberInfo.memberEmail = data.email;
	}

	setUserInfo(userInfo);
}

/**
 * Update checkbox values on My Preference view
 */
const updatePreference = () => {
	let userInfo = getUserInfo();
	document.querySelector('#preferencesUpdateForm')?.addEventListener('change', function (event) {
		if (event.target.value) {
			event.target.disabled = true;

			fetchAction(
				{
					'verity_guest_action': '/api/PreferencesNew',
					'verity_guest_method': 'PUT',
					'acid': userInfo.acid,
					'preferencesElement': JSON.stringify([
						{
							'updatedtagCode': event.target.name.replace('tagCode_', ''),
							'updatedvalTagId': event.target.id.replace('tagID_', ''),
							'updatedvalue': event.target.type === 'checkbox' ? String.prototype.toUpperCase.call(event.target.checked) : event.target.value,
						}
					])
				}
			).then(response => {
				event.target.disabled = false;
				toastInit(200 === response.data.errorCode ? verityObj.messages.preferenceUpdated : response.data.errorMessage);
			});
		}
	});
}

const redirectToDashboard = () => {
	setTimeout(function () {
		console.log('redirectToDashboard')
		window.location.replace(verityObj.dashboardPermalink);
	}, 2000);
}

const triggerDatePickers = () => {
	const openDatePickerEls = document.querySelectorAll('.trigger-date-picker');
	Array.from(openDatePickerEls).forEach((openDatePickerEl) => {
		openDatePickerEl.addEventListener('click', (e) => {
			e.preventDefault();
			const datePickerEl = openDatePickerEl.parentElement.querySelector('input[type="date"]');
			if (datePickerEl && datePickerEl.hasOwnProperty('showPicker')) {
				datePickerEl.showPicker();
			}
		}, false);
	});
}

const triggerTooltips = () => {
	const tooltipTriggerList = document.querySelectorAll('[data-toggle="tooltip"], [data-bs-toggle="tooltip"]');
	[...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
}

const triggerDropdowns = () => {
	const dropdownElementList = document.querySelectorAll('[data-toggle="dropdown"], [data-bs-toggle="dropdown"]');
	[...dropdownElementList].map(dropdownToggleEl => new Dropdown(dropdownToggleEl));
}

const triggerTabs = () => {
	const bootstrapDataAttr = getBootstrapDataAttr();
	const triggerEls = document.querySelectorAll(`[${bootstrapDataAttr}-trigger="tab"]`);
	const tabEls = document.querySelectorAll(`[${bootstrapDataAttr}-toggle="tab"]`);
	const tab = new URL(location.href).searchParams.get('tab');
	Array.from(triggerEls).forEach((triggerEl) => {
		triggerEl.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();

			let selectEl = document.getElementById('subject');
			if (e.target.dataset.subject && selectEl) {
				selectEl.value = e.target.dataset.subject;
				selectEl.dispatchEvent(new Event('input', { bubbles: true }))
			}

			const triggerTargetEL = document.querySelector(`[${bootstrapDataAttr}-toggle="tab"][${bootstrapDataAttr}-target="${triggerEl.getAttribute(`${bootstrapDataAttr}-target`)}"]`);
			if (triggerTargetEL) {
				scrollToTop();
				triggerTargetEL.click();
			}
		}, false);
	});

	Array.from(tabEls).forEach(tabEl => {
		if (document.body.classList.contains('bootstrap4') && 'function' === typeof jQuery) {
			$(tabEls).on('shown.bs.tab', function (e) {
				// Don't scroll to the top to electra external partner tabs.
				if (!e.currentTarget.parentElement.parentElement.classList.contains('external-partner-tabs')) {
					scrollToTop();
					locomotiveScrollUpdate();
				}

				// Needed for electrahotels partners filtering.
				dispatchEvent(new CustomEvent('verity-guest.shown.bs.tab'));
			});
		} else {
			tabEl.addEventListener('shown.bs.tab', (e) => {
				// Don't scroll to the top to electra external partner tabs.
				if (!e.currentTarget.parentElement.parentElement.classList.contains('external-partner-tabs')) {
					scrollToTop();
					locomotiveScrollUpdate();
				}

				// Needed for electrahotels partners filtering.
				dispatchEvent(new CustomEvent('verity-guest.shown.bs.tab'));
			});
		}
	});

	if (tab) {
		const triggerEl = document.querySelector(`#loyalty-dashboard-tabs button[${bootstrapDataAttr}-target="#${tab}"]`);
		if (triggerEl) {
			triggerEl.click()
			clearURLQueryStrings();
		}
	}
}

const switchToTab = () => {
	const tab = new URL(location.href).searchParams.get('tab');
	if (tab) {
		const bootstrapDataAttr = getBootstrapDataAttr();
		const triggerEl = document.querySelector(`#loyalty-dashboard-tabs button[${bootstrapDataAttr}-target="#${tab}"]`);
		if (triggerEl) {
			triggerEl.click()
			clearURLQueryStrings();
		}
	}
}

/**
 * Switch to join tab so the message is visible.
 */
const switchToJoinTab = () => {
	const bootstrapDataAttr = getBootstrapDataAttr();
	const triggerEl = document.querySelector(`#loyaltyJoinTab button[${bootstrapDataAttr}-target="#signUp"]`);
	if (triggerEl) {
		triggerEl.click()
	}
}

const scrollToTop = () => {
	const tabsContent = document.getElementById('verity-guest-loyalty-content');
	if (tabsContent) {
		if ('undefined' !== typeof window.locomotiveScroll) {
			window.locomotiveScroll.scrollTo(tabsContent, {offset: -108, duration: 100});
		} else {
			tabsContent.scrollIntoView({block: 'start', behavior: 'smooth'});
		}
	}
}

const getUserInfo = () => {
	let data = window.localStorage.getItem('verityGuestUserInfo');

	return data ? JSON.parse(data) : {};
}

const setUserInfo = (data) => {
	if ('object' === typeof data) {
		window.localStorage.setItem('verityGuestUserInfo', JSON.stringify(data));
	}
}

const getCookie = (name) => {
	let cookieArr = document.cookie.split(";");

	for (let i = 0; i < cookieArr.length; i++) {
		let cookiePair = cookieArr[i].split("=");
		if (name === cookiePair[0].trim()) {
			return decodeURIComponent(cookiePair[1]);
		}
	}

	return null;
}

const clearURLQueryStrings = () => {
	window.history.replaceState({}, document.title, window.location.pathname);
}

/**
 * @param data
 * @param rememberMe
 * @property localStorage
 * @property sessionStorage
 */
const setCookies = (data, rememberMe) => {
	if (data && data.hasOwnProperty('acid') && data.hasOwnProperty('acidToken')) {
		window.localStorage.setItem('verityGuestIsLoggedIn', 'true');
		document.cookie = `acidToken=${data.acidToken}; ${'on' === rememberMe ? 'max-age=86400;' : ''} SameSite=Strict; Secure; path=/;`;
		document.cookie = `acidCode=${btoa(data.acid)}; ${'on' === rememberMe ? 'max-age=86400;' : ''} SameSite=Strict; Secure; path=/;`;

		if (data.hasOwnProperty('memberInfo') && data.memberInfo.hasOwnProperty('cMemberTier')) {
			window.sessionStorage.setItem('acidTier', data.memberInfo.cMemberTier);
		}

		if (data.hasOwnProperty('webhotelierSmartGuest')) {
			document.cookie = `webhotelierSmartGuest=${data.webhotelierSmartGuest}; max-age=86400; SameSite=Strict; Secure; path=/;`;
		}
	}
}

/**
 * @property localStorage
 * @property sessionStorage
 */
const removeCookies = () => {
	window.localStorage.removeItem('verityGuestIsLoggedIn');
	window.localStorage.removeItem('verityGuestUserInfo');
	document.cookie = 'acidToken=; max-age=-1; SameSite=Strict; Secure; path=/;';
	document.cookie = 'acidCode=; max-age=-1; SameSite=Strict; Secure; path=/;';
	document.cookie = 'webhotelierSmartGuest=; max-age=-1; SameSite=Strict; Secure; path=/;';
	window.sessionStorage.removeItem('acid');
	window.sessionStorage.removeItem('acidTier');
}

/**
 * @param data
 * @property eMailToken
 */
const updateBookNowEls = (data = null) => {
	if ('object' === typeof data && data.eMailToken) {
		const bookNowEls = document.querySelectorAll('a[href*=".reserve-online.net"]');
		Array.from(bookNowEls).forEach((bookNowEl) => {
			/**
			 * DO not delete yet. Maybe we need the webhotelier urls in the future.
			 * @type {module:url.URL}
			 */
				// Adds loginToken to book now url's.
				// let bookURL = new URL(bookNowEl.href);
				// bookURL.searchParams.set('loginToken', data.eMailToken);

				// Redirect to loyalty page.
			let bookURL = new URL(verityObj.dashboardPermalink);
			bookNowEl.target = '_self';
			bookURL.searchParams.set('tab', 'loyalty-book-now');

			bookNowEl.href = bookURL;
		});
	}
}

/**
 * @property bookNowUri
 */
const hotelSelectChange = () => {
	document.addEventListener('input', function (event) {
		// Only run for #BookNowHotel or #RedeemHotel select.
		if (event.target.id !== 'BookNowHotel' && event.target.id !== 'RedeemHotel') return;

		const form = event.target.closest('form');
		const locations = JSON.parse(form.dataset.locations);
		const location = locations.filter(loc => loc.description === event.target.value).shift();
		if ('object' === typeof location && 'undefined' !== typeof location.bookNowUri) {
			form.action = location.bookNowUri;
		}

	}, false);
}

/**
 * @property todayDate
 */
const missingPointsDatesOnSubjectSelect = () => {
	document.addEventListener('input', function (event) {
		// Only run for #subject select dropdown missing points form.
		if (event.target.id !== 'subject') return;

		let form = event.target.closest('form');
		let todayDate = form.dataset.todayDate;
		let arrivalDate = form.querySelector('#arrivalDate');
		let departureDate = form.querySelector('#departureDate');

		if ('missing-points' === event.target.value) {
			arrivalDate.setAttribute('min', '');
			departureDate.setAttribute('min', '');
			arrivalDate.setAttribute('max', todayDate);
			departureDate.setAttribute('max', todayDate);
		} else {
			// Missing reservations may be for past or upcoming stays, so no limits.
			arrivalDate.setAttribute('min', '');
			departureDate.setAttribute('min', '');
			arrivalDate.setAttribute('max', '');
			departureDate.setAttribute('max', '');
		}
	}, false);
}

/**
 * @param form
 * @param active
 */
const handleSubmitButton = (form, active) => {
	const button = form.querySelector('button[type="submit"]');
	const buttonSpinner = form.querySelector('.spinner-border');
	const buttonText = form.querySelector('.btn-text');

	if (buttonSpinner && buttonText && button) {
		if (active) {
			buttonSpinner.classList.add('d-none');
			buttonText.classList.remove('d-none');
			button.classList.remove('disabled');
			button.removeAttribute("disabled", "");
		} else {
			buttonSpinner.classList.remove('d-none');
			buttonText.classList.add('d-none');
			button.classList.add('disabled');
			button.setAttribute("disabled", "");
		}
	}
}

/**
 * @param formID
 * @param message
 * @param status
 */
const handleMessage = (formID, message, status = 'danger') => {
	const messageEL = document.querySelector(`#${formID} .form-message`);
	if (messageEL) {
		messageEL.innerText = message;
		if (message === "") {
			messageEL.classList.add('d-none');
			messageEL.classList.remove('alert', 'alert-success', 'alert-danger');
		} else {
			messageEL.classList.remove('d-none');
			messageEL.classList.add('alert', 'alert-' + status);
		}
	}
}

/**
 * @param data
 */
const initChangeViewLinks = (data = null) => {
	const forgotPasswordEl = document.getElementById('verity-guest-loyalty-forgot-password');
	if (forgotPasswordEl) {
		forgotPasswordEl.addEventListener('click', (e) => {
			e.preventDefault();
			new RenderView('forgot-password');
		});
	}

	const changePasswordEl = document.getElementById('verity-guest-loyalty-change-password');
	if (changePasswordEl) {
		changePasswordEl.addEventListener('click', (e) => {
			e.preventDefault();
			new RenderView('change-password', data);
		});
	}

	const dashboardEl = document.getElementById('verity-guest-loyalty-dashboard');
	if (dashboardEl) {
		dashboardEl.addEventListener('click', (e) => {
			e.preventDefault();
			data = getUserInfo();
			new RenderView('dashboard', data);
		});
	}

	const joinEl = document.getElementById('verity-guest-loyalty-join');
	if (joinEl) {
		joinEl.addEventListener('click', (e) => {
			e.preventDefault();
			new RenderView('join');
		});
	}
}

const initMenuLink = (data = null) => {
	const loyaltyMenuLinkContainer = document.getElementById('verity-guest-loyalty-menu-link');
	if (loyaltyMenuLinkContainer) {
		if (null === data) {
			data = getUserInfo();
		}
		data.dashboardPermalink = verityObj.dashboardPermalink;
		data.dashboardPermalinkTarget = verityObj.dashboardPermalinkTarget;
		let verityTemplate = wp.template('verity-guest-loyalty-menu-link');
		loyaltyMenuLinkContainer.innerHTML = verityTemplate(data);
		if (getCookie('acidToken')) {
			document.body.classList.add('verity-guest-loyalty-signed-in');
		}
	}

	initSignOutLinks();
}

const initSignOutLinks = () => {
	const logoutLinkEls = document.querySelectorAll('.verity-guest-loyalty-logout');
	Array.from(logoutLinkEls).forEach((logoutLinkEl) => {
		logoutLinkEl.addEventListener('click', (e) => {
			e.preventDefault();
			removeCookies();
			location.reload();
		}, false);
	});
}

const getBootstrapDataAttr = () => {
	return document.body.classList.contains('bootstrap4') ? 'data' : 'data-bs';
}

const locomotiveScrollUpdate = () => {
	if ('undefined' !== typeof window.locomotiveScroll) {
		window.locomotiveScroll.update();
	}
}

const triggerPasswordReveal = () => {
	const passwordRevealEls = document.querySelectorAll('.input-password-reveal');
	Array.from(passwordRevealEls).forEach((passwordRevealEl) => {
		passwordRevealEl.addEventListener('click', (e) => {
			e.preventDefault();
			const inputEl = passwordRevealEl.closest('.input-group').querySelector('input');
			const passwordRevealIconShowEl = passwordRevealEl.querySelector('.icon-show');
			const passwordRevealIconHideEl = passwordRevealEl.querySelector('.icon-hide');

			if (inputEl.type === 'password') {
				inputEl.type = 'text';
				passwordRevealIconShowEl.classList.add('d-none');
				passwordRevealIconHideEl.classList.remove('d-none');
			} else {
				inputEl.type = 'password';
				passwordRevealIconShowEl.classList.remove('d-none');
				passwordRevealIconHideEl.classList.add('d-none');
			}
		}, false);
	});
}

const triggerGoogleAnalyticsFormSubmit = (form) => {
	// Google Analytics Event.
	if (typeof ga === 'function') {
		ga('send', 'event', 'Verity Guest Loyalty form #' + form.id + ' submit', form.id.replace('Form', ' submit'));
	}
}

/**
 * @param message
 * @param autohide
 */
const toastInit = (message, autohide = true) => {
	if ('undefined' === typeof Toast) {
		console.warn(message);
	} else {
		const bootstrapDataAttr = getBootstrapDataAttr();
		const htmlMarkup = `
			<div class="toast text-light bg-primary border-0 p-3" role="alert" aria-live="assertive" aria-atomic="true" ${bootstrapDataAttr + '-autohide'}="${autohide}" ${bootstrapDataAttr + '-delay'}="${autohide ? 7500 : 0}">
				<div class="toast-body d-flex align-items-center justify-content-between w-100">
					<span>${message}</span>
					<button type="button" class="btn-close btn-close-white close close-white ms-2" ${bootstrapDataAttr + '-dismiss'}="toast" aria-label="${verityObj.messages.close}">
						${bootstrapDataAttr === 'data' ? '<span aria-hidden="true">&times;</span>' : ''}
					</button>
				</div>
			</div>
		`;

		let template = document.createElement('template');
		template.innerHTML = htmlMarkup.trim();
		let toastEl = template.content.firstChild;
		let toastContainer = document.getElementById('toastContainer');
		if (toastContainer) {
			toastContainer.appendChild(toastEl);
			const alertToast = new Toast(
				toastEl,
				{
					autohide: autohide,
					delay: autohide ? 7500 : 0
				}
			);
			alertToast.show();
		}
	}
}

/**
 * @param string
 */
_.uppercaseFirstLetter = (string) => {
	return typeof string === 'string' ? string.charAt(0).toUpperCase() + string.slice(1) : null;
}

/**
 * Format Date in Greece Timezone
 *
 * @param date Date
 */
_.template.formatDate = function (date) {
	return new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/Athens'}).format(new Date(date));
};

/**
 * @param date
 */
_.template.formatBirthday = function (date) {
	let d = new Date(date)
	let fragments = [
		d.getFullYear(),
		('0' + (d.getMonth() + 1)).slice(-2),
		('0' + d.getDate()).slice(-2)
	];

	return fragments.join('-');
};

Array.prototype.contains = function (element) {
	return this.indexOf(element) > -1;
};

/**
 * @param date
 */
const App = {
	init() {
		new Auth();
	}
}

/**
 * @param onLoaded
 * @property attachEvent
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		})
	}
}

domLoaded(() => {
	App.init()
});

window.neliosVerityGuestLoyaltyValidateForm = ValidateForm;
window.neliosVerityGuestLoyaltyRemoveCookies = removeCookies;
window.neliosVerityGuestLoyaltyGetUserInfo = getUserInfo;
